import { render, staticRenderFns } from "./UserDeleteModal.vue?vue&type=template&id=23b1a630&scoped=true&"
import script from "./UserDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./UserDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1a630",
  null
  
)

export default component.exports